// extracted by mini-css-extract-plugin
export default {"header":"AuthLayout_header__Klj7C","footer":"AuthLayout_footer__Whvhz","contentWrapper":"AuthLayout_contentWrapper__L5Ot4","headerBackButton":"AuthLayout_headerBackButton__L2SV4"};